import { __assign, __rest } from "tslib";
import React, { useRef } from 'react';
import * as ReactDOM from 'react-dom';
import ToolbarWrapper from './ToolbarWrapper';
var PORTAL_ELEMENT_DEFAULT_ID = 'inline-texttools-portal';
var Portal = function (_a) {
    var children = _a.children, portalId = _a.portalId;
    var containerId = portalId || PORTAL_ELEMENT_DEFAULT_ID;
    var container = useRef(document.getElementById(containerId));
    if (!container.current) {
        var el = document.createElement('div');
        el.id = containerId;
        document.body.appendChild(el);
        container.current = el;
    }
    return ReactDOM.createPortal(children, container.current);
};
var PortalWrapper = function (_a) {
    var children = _a.children, refCallback = _a.refCallback, portalId = _a.portalId, props = __rest(_a, ["children", "refCallback", "portalId"]);
    var style = __assign(__assign({}, props.style), { zIndex: 9999999 });
    return (React.createElement(Portal, { portalId: portalId },
        React.createElement(ToolbarWrapper, null,
            React.createElement("div", { dir: "" },
                React.createElement("div", __assign({}, props, { ref: refCallback, style: style }), children)))));
};
export default (function (_a) {
    var portalId = _a.portalId;
    return function () {
        var Component = function () { return function (props) { return (React.createElement(PortalWrapper, __assign({ portalId: portalId }, props))); }; };
        return {
            desktop: Component,
            mobile: {
                ios: Component,
                android: Component,
            },
        };
    };
});
//# sourceMappingURL=PortalDecorator.js.map